import { AgendamentoTestDrive } from "../../sections/AgendamentoTestDrive/AgendamentoTestDrive"
import type { AgendamentoTestDriveProps } from "../../sections/AgendamentoTestDrive/types"
import { useGlobalQueryParams } from "../../hooks/queryParams/useGlobalQueryParams"

/** Wrapper Next.js (renderer): injeta `useGlobalQueryParams` (região/URL) na seção
    framework-agnostic. A `dynamicStructure` (catálogo + canal) é resolvida internamente
    pela seção via `mapEntries`. O preview do veículo usa o `VehicleMedia` compartilhado
    (giro 360 via `<img>`, federation-safe) — não injeta `next/image`. */
export const AgendamentoTestDriveWrapper = (props: AgendamentoTestDriveProps) => (
  <AgendamentoTestDrive {...props} useGlobalQueryParams={useGlobalQueryParams} />
)

export default AgendamentoTestDriveWrapper
